import React, { useEffect } from 'react'
import {
  LogoSmallText,
  LogoBigText,
  Logo,
  ImageWrap,
  Anchor,
  Container,
  Content,
  Heading,
  Para,
  Wrapper,
} from 'modules/Onboarding/Components/NotInterested/FinalPage/style'
import Done from 'components/images/done.png'
import Flex from 'components/Flex'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getCollege, getStudentData } from 'modules/Onboarding/actions'

const FinalPageNI = () => {
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useDispatch()
  const studentId = params.studentId
  const studentData = useSelector(state => state?.studentData?.studentDetails)

  useEffect(() => {
    if (studentData?.currentState === 0) {
      navigate(`/not-interested/${studentId}`)
    }
  }, [studentData])

  useEffect(() => {
    dispatch(getStudentData(studentId))
  }, [studentId])

  useEffect(() => {
    if (studentData?.instituteCampusId) {
      dispatch(getCollege(studentData?.instituteCampusId))
    }
  }, [studentData])

  return (
    <Container alignCenter column>
      <Wrapper>
        <Content center alignCenter column>
          <ImageWrap>
            <img src={Done} alt="done" />
          </ImageWrap>
          <Flex column alignCenter center>
            <Heading>Thank you for letting us know</Heading>
            <Para>
              You will not receive any placement related notification going
              forward.
            </Para>
          </Flex>
          <Anchor href={'http://pluginlive.com'} target="_blank">
            Visit 'PluginLive.com'
          </Anchor>
        </Content>
        <Logo center alignCenter column>
          <LogoSmallText>Powered by</LogoSmallText>
          <LogoBigText>PluginLive</LogoBigText>
        </Logo>
      </Wrapper>
    </Container>
  )
}

export default FinalPageNI
